/**
 * Der Weg vom Test zum richtigen Zugang.
 *
 * In der Kopfzeile steht ein gefuellter blauer Knopf (Variante A, Sven, 20.09.2026). Er oeffnet eine fertig geschriebene Mail an Louis,
 * damit der Steuerberater nur noch seine Angaben ergaenzt und abschickt. Der Klick wird ans CRM
 * gemeldet (Hat Interesse); die Mail selbst oeffnet das Mailprogramm, wir sehen nur den Klick.
 *
 * Wie viel vom Kontingent noch frei ist, steht als Satz im Eingang neben Offen und Alle
 * (Testkontingent unten), nicht in der Kopfzeile (Sven, 20.09.2026).
 */
import type { Teststand } from '../lib/test'
import { api } from '../lib/api'

const EMPFAENGER = 'louis.honal@hks-automation.de'

export function anfrageMailto(): string {
  const betreff = 'Zugang zum Kontoauszug-Werkzeug'
  const text = [
    'Hallo Louis,',
    '',
    'ich habe das Werkzeug getestet und hätte gern einen Zugang für unsere Kanzlei.',
    '',
    'Kanzlei:',
    'Ansprechpartner:',
    'Telefon für den Rückruf:',
    'Etwa wie viele Auszüge im Monat:',
    '',
    'Viele Grüße',
  ].join('\n')
  return `mailto:${EMPFAENGER}?subject=${encodeURIComponent(betreff)}&body=${encodeURIComponent(text)}`
}

export function anfrageMelden(): void {
  void api.senden('/api/test/anfrage', {}).catch(() => undefined)
}

export function Zugangsanfrage() {
  return (
    <a className="knopf gefuellt zugangsanfrage" href={anfrageMailto()} onClick={anfrageMelden}>
      Zugang für die Kanzlei anfragen
    </a>
  )
}

/**
 * Die Auskunft im Eingang: was vom Test noch frei ist. Steht neben dem Hochladen Knopf, leise,
 * ohne Rahmen. Erst wenn nichts mehr frei ist, kommt der Weg zum Zugang dazu, weil das der
 * Moment ist, in dem er gebraucht wird (Sven, 20.09.2026).
 */
export function Testkontingent({ stand }: { stand: Teststand }) {
  if (!stand.test || !stand.angemeldet) return null
  const frei = Math.max(0, stand.auszuegeGrenze - (stand.auszuege ?? 0))
  if (frei === 0) {
    return (
      <span className="testkontingent aufgebraucht">
        Testkontingent aufgebraucht<span className="trenner" aria-hidden="true" />
        <a className="verweis" href={anfrageMailto()} onClick={anfrageMelden}>
          Zugang für die Kanzlei anfragen
        </a>
      </span>
    )
  }
  return (
    <span className="leiser testkontingent">
      {frei === 1 ? 'Noch ein Auszug frei' : `Noch ${frei} von ${stand.auszuegeGrenze} Auszügen frei`}
    </span>
  )
}
